import { IS_CLIENT } from '../../constants';
import { getWrappedSrc } from './getWrappedSrc';
const liquidPixelResolutionMapping = {
    88: '88',
    150: '150',
    250: '250',
    376: '376',
    456: '456',
    600: '600',
    768: '768',
    1024: '1024',
    1440: '1440',
};
export const sizes = Object.keys(liquidPixelResolutionMapping);
export const wrapRewardSummaryImageSrc = (src, closestWidth, useDevPrefixedUrl) => {
    const httpSrc = src.includes('http') || !IS_CLIENT ? src : `${window.location.origin}${src}`;
    return getWrappedSrc(httpSrc, liquidPixelResolutionMapping[closestWidth], useDevPrefixedUrl);
};
//# sourceMappingURL=rewardSummaryImageMappings.js.map